/**
 * Web client bootstrap. Picks the link page or voice page based on whether
 * a refresh token is in localStorage; remounts when the user links or
 * unlinks so the two pages don't need to know about each other.
 */

import { getRefreshToken } from './auth.ts'
import { renderLinkPage } from './pages/link.ts'
import { renderVoicePage } from './pages/voice.ts'

const root = document.getElementById('root')
if (root === null) {
  throw new Error('#root not in DOM; check index.html')
}

function mountCurrent(): void {
  if (root === null) return
  const token = getRefreshToken()
  if (token === null || token.length === 0) {
    renderLinkPage({ root, onLinked: mountCurrent })
  } else {
    renderVoicePage({ root, onUnlinked: mountCurrent })
  }
}

mountCurrent()
